// extracted by mini-css-extract-plugin
export var paginationContainer = "_7x-0";